<template>
  <f7-page ref="page">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>
        <f7-link style="padding: 0px;" @click="toggleChannel">
          <span id="title" style="font-size: 48px;">{{currentStation}}</span>
          <div v-if="!currentStation" id="subtitle">站點選擇</div>
        </f7-link>
      </f7-nav-title>
      <f7-nav-right>
        <f7-link @click="syncAllOrderChannels">
          <font-awesome-icon icon="sync-alt" />
        </f7-link>
        <f7-link @click="setFullscreen(true)">
          <font-awesome-icon icon="expand" />
        </f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template v-if="isWorkMainChannel">
      <div>
        <f7-list>
          <f7-list-item
            v-for="(orderItem, key) in orderItems"
            :key="`workStation-item-${key}`"
            :style="{ color: orderTextColor(orderItem) ,'background-color': orderBackgroundColor(orderItem) }">
            <div class="order-item-container"
              :style="{ 'font-size': fontSize + 'px', 'line-height': fontSize + margin + 'px' }">
              <div class="order-item-left-side">
                <h2 :style="{ margin: '0px', fontSize: fontSize + 'px', fontWeight: 'normal' }">
                  {{ orderItem.info.nickname }}
                </h2>
                <div
                  class="order-item-row"
                  v-for="(item, key) in orderItem.items"
                  :key="`order-item-row-${key}`"
                  :style="{ fontSize: settings.fontSize * 1.25 + 'px', margin: `${margin}px 5px ${margin + 3}px 0px` }">
                  <div
                    v-for="(element, index) in item.items"
                    :key="`order-item-cell-${index}`"
                    class="order-item-cell"
                    @click="toggleItemState(element.key)"
                    v-bind:class="{ 'item-line-through' : getStationItemState(element.key)[currentStateKey] === 'done' }">
                    - {{ element.title }} {{ element.number !== undefined ? `* ${element.number} ` : '' }}
                    <span
                      style="margin: 0px 0px 0px 10px;"
                      v-for="(option, key) in element.options"
                      :key="`subItem-option-${key}`">
                      {{ option.title }} {{ option.number === undefined ?  '' : `* ${option.number}` }}
                    </span>
                  </div>
                  <div class="item-list__special-request" v-if="item.specialRequests">
                    <div class="item-list__special-request-title">
                      備註: {{ item.specialRequests }}
                    </div>
                    {{ item.id }}
                    <div class="item-list__special-request-icon" @click.stop="showFullSpecialRequest(orderItem.info.orderId, item.instanceId)">
                      <font-awesome-icon icon="arrows-alt"  />
                    </div>
                  </div>
                </div>
              </div>
              <div class="order-item-right-side">
                <span :style="{ color: orderTextColor(orderItem), fontSize: settings.fontSize * 1.5 }">
                  {{ getDiningReferenceCh(orderItem) }}
                </span>
                <span :style="{color: '#888888', fontWeight: 'normal', fontSize: settings.fontSize * 1.25 + 'px'}">
                  {{ getOrderItemTime(orderItem) }}
                </span>
              </div>
            </div>
          </f7-list-item>
        </f7-list>
      </div>
    </template>
    <template v-else>
      <f7-list>
        <f7-list-item group-title title="工作站點" />
        <f7-list-item
          swipeout
          v-for="(workStation, key) in workStationList"
          :key="`workStation-${key}`"
          :title="workStation.id"
          @click="setCurrentWorkStation(workStation.id)">
          <f7-swipeout-actions right>
            <f7-swipeout-button
              close
              @click="removeWorkStation(workStation.id)"
              style="backgroundColor: #F44336">
              刪除
            </f7-swipeout-button>
          </f7-swipeout-actions>
        </f7-list-item>
      </f7-list>
      <f7-list>
        <f7-list-item title="新增站點" group-title></f7-list-item>
        <f7-list-item ref="tempWorkStation">
          <f7-label>工作站名稱</f7-label>
          <f7-input type="text" :value="tempWorkStation" @input="tempWorkStation = $event.target.value" clear-button/>
          <f7-button raised fill @click="createWorkStation" style="margin-top: 15px">新增</f7-button>
        </f7-list-item>
      </f7-list>
    </template>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import OrderListItem from '../components/OrderListItem'
import NavbarCenter from '@/common/components/NavbarCenter'
import moment from 'moment'
import { storeClient } from '@/service/apiClients'
import storeMenuHelp from '@Util/menu/storeMenuHelp'
import caseTempState from '@Usecase/storeCase/tempState'
import managerWorkStation from '@Manager/storeManager/workStation'
import currMenuMansger from '@Manager/menu/currMenuMansger'
import caseWorkStation from '@Usecase/storeCase/workStation'
import caseMenus from '@Usecase/menuCase/menuCase'
import injector from 'vue-inject'
import { playBumblebee, stopAudio } from '@/service/audioPlayer'

export default {
  dependencies: [
    'platformUtils',
    'filterConfigs',
    'diningPreferenceType'
  ],
  mixins: [caseTempState, managerWorkStation, caseWorkStation, currMenuMansger, caseMenus],
  data () {
    return {
      orderItems: [],
      platform: process.env.VUE_APP_PLATFORM,
      newOrderAlertPlaying: false,
      sound: null,
      syncOrderIntervalId: null,
      tempWorkStation: '' // 新增工作站時暫存的變數
    }
  },
  props: {
    storeIdProp: String
  },
  computed: {
    ...mapState(['currentMinute', 'socketId', 'store']),
    ...mapState('orderModule', ['newOrder', 'channels']),
    ...mapState('menuModule', ['menus', 'latestVersions']),
    ...mapState('itemstateModule', ['itemGather']),
    ...mapState('userModule', ['uid']),
    ...mapState(['settings']),
    ...mapGetters('itemstateModule', ['getStationItemState']),
    ...mapGetters(['storeId']),
    ...mapGetters('orderModule', ['mainOrderList', 'secondaryOrderList']),
    currentChannel () { return this.channels['main'] },
    shortcutChannel () { return this.channels[this.isWorkMainChannel ? 'secondary' : 'main'] },
    fontSize () {
      return this.settings.fontSize
    },
    margin () {
      return this.settings.margin
    },
    currentStateKey () {
      return `${this.currentStation}-station_state`
    }
  },
  watch: {
    socketId (id) {
      if (this.uid) { // 代表 Auth 過了
        this.syncAllOrderChannels()
        if (id) {
          clearInterval(this.syncOrderIntervalId)
        } else {
          this.syncOrderIntervalId = setInterval(this.syncAllOrderChannels, 5000)
        }
      }
    },
    currentStation: function (station) {
      this.parseOrderData()
    },
    currentMinute: function (currentMinute) {
      this.parseOrderData()
    },
    'currentChannel.orderList': function (list) {
      this.currentChannel.orderList.forEach(async order => {
        await this.downloadMenu({ version: order.menuVersion, variation: order.menuVariation })
      })
      this.parseOrderData()
    },
    menus: {
      handler: function (menus, oldmenus) {
        if (Object.keys(menus).length > 0) {
          this.parseOrderData()
        }
      },
      deep: true
    },
    workStationList () {
      this.parseOrderData()
    },
    async uid (v) {
      if (this.storeId) {
        Object.keys(this.channels).forEach(channel => { this.syncOrderChannel({ channel }) })
      }
    },
    newOrder (newOrder) {
      if (newOrder.diningPreference === this.diningPreferenceType.preOrder && this.settings.preOrderRing) {
        const that = this
        playBumblebee(true)
        this.newOrderAlertPlaying = true
        this.$f7.notification.create({
          title: '網路預約訂單',
          titleRightText: '下單時間: ' + moment(newOrder.receivedAt).format('MM/DD HH:mm'),
          subtitle: newOrder.nickname,
          text: '取餐時間: ' + moment(newOrder.pickupTime).format('MM/DD HH:mm'),
          closeOnClick: true,
          closeButton: true,
          on: {
            close () {
              stopAudio()
              that.newOrderAlertPlaying = false
            }
          }
        }).open()
      }
    }
  },
  async created () {
    if (!this.storeId) {
      await this.setStore(this.storeIdProp)
    }
    if (this.uid) {
      this.downloadMenu({})
      this.syncAllOrderChannels()
      this.syncStoreTempState()
      this.syncStationList()
      this.quickSearch(this.filterConfigs.getKitchenFilterConfig)
    }
    await this.asyncStoreData()
    this.syncAllOrderChannels() // 資料取得之後要在同步一次所有的訂單資料
  },
  beforeDestroy () {
    clearInterval(this.syncOrderIntervalId)
  },
  methods: {
    ...mapActions(['setStore', 'setFullscreen', 'setStoreData', 'asyncStoreData']),
    ...mapActions('orderModule', ['syncOrderChannel']),
    ...mapActions('menuModule', ['downloadMenu']),
    parseOrderData () {
      // 需要等 storeSetting 的資料回傳之後執行才有群組畫線的 flag
      if (!this.currentChannel.orderList || Object.keys(this.menus).length === 0 || !injector.get('storeSetting').store) return
      this.orderItems = []
      const { items: data } = storeMenuHelp.orderRowToWorkStationFormat(this.workStationMap, this.currentStation, this.menus, this.currentChannel.orderList, this.store, this.currentMinute)
      this.orderItems = data
    },
    getDiningReferenceCh (orderItem) {
      if (orderItem.info.diningPreference === this.diningPreferenceType.forHere) {
        return orderItem.info.tableNumber
      } else if (orderItem.info.diningPreference === this.diningPreferenceType.takeAway) {
        return '外帶'
      } else if (orderItem.info.diningPreference === this.diningPreferenceType.preOrder) {
        return '預約外帶'
      }
    },
    getOrderItemTime (orderItem) {
      return orderItem.info.pickupTime ? moment(orderItem.info.pickupTime).format('HH:mm') : null
    },
    async toggleItemState (key) { // 設定 item 做完
      const value = this.getStationItemState(key)[this.currentStateKey] === 'done' ? 'no' : 'done'

      try {
        await storeClient.put(`/stores/${this.storeId}/itemTempState`, {
          itemId: key,
          key: this.currentStateKey,
          value
        })
      } catch (e) {
        console.error(e)
      }
    },
    removeWorkStation (kitchenStationId) {
      this.$f7.dialog.confirm(`確認刪除 ${kitchenStationId} ? `, '刪除站點', async () => {
        try {
          await storeClient.delete(`/stores/${this.storeId}/kitchenStation/${kitchenStationId}`)
        } catch (e) {
          console.error(e)
          this.$f7.dialog.alert('刪除站點失敗', '請檢查網路狀況')
        }
      })
    },
    showFullSpecialRequest (orderId, itemObjId) {
      this.$f7router.navigate(`/stores/${this.storeId}/order-details/${orderId}/items/${itemObjId}/special-requests-popup`)
    },
    orderTextColor (orderItem) {
      if (orderItem.info.diningPreference === this.diningPreferenceType.forHere) {
        return '#000000'
      } else if (orderItem.info.diningPreference === this.diningPreferenceType.preOrder) {
        return '#0080A9'
      } else {
        return '#134290'
      }
    },
    syncAllOrderChannels () {
      Object.keys(this.channels).forEach(channel => { this.syncOrderChannel({ channel }) })
    },
    async createWorkStation () { // 新增工作站
      if (this.tempWorkStation.trim().length === 0) {
        return this.$f7.dialog.alert('請輸入站點名稱', '新增站點失敗')
      }
      await storeClient.post(`stores/${this.storeIdProp}/kitchenStations`, { nameId: this.tempWorkStation })
      this.tempWorkStation = ''
    },
    toggleChannel () {
      this.toggleMainChannel()
    },
    orderBackgroundColor (item) {
      if (item.info.diningPreference === this.diningPreferenceType.preOrder) {
        return '#F8D7DA'
      } else {
        return '#FFFFFF'
      }
    },
    async quickSearch (getFilterConfig) {
      try {
        this.$f7.dialog.progress()
        await this.syncOrderChannel({ channel: 'main', getFilterConfig })
        this.$utils.nextFrame(() => this.$f7.dialog.close())
      } catch (e) {
        this.$utils.nextFrame(() => this.$f7.dialog.close())
        this.$f7.dialog.alert('無法取得餐點', '網路連線失敗')
      }
    },
    scanQrCode () {
      // eslint-disable-next-line
      cordova.plugins.barcodeScanner.scan(async result => {
        const { data: order } = await storeClient.get(`/stores/${this.storeId}/orders/${result.text}`)
        this.$f7router.navigate(`/stores/${this.storeId}/order-details/${order.id}?t=details`)
      }, error => {
        alert('Scanning failed: ' + error)
      }, {
        preferFrontCamera: false, // iOS and Android
        showFlipCameraButton: true, // iOS and Android
        showTorchButton: true, // iOS and Android
        torchOn: false, // Android, launch with the torch switched on (if available)
        saveHistory: false, // Android, save scan history (default false)
        prompt: '請將 QR Code 對準框框', // Android
        resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
        formats: 'QR_CODE,PDF_417', // default: all but PDF_417 and RSS_EXPANDED
        orientation: 'portrait', // Android only (portrait|landscape), default unset so it rotates with the device
        disableAnimations: true, // iOS
        disableSuccessBeep: false // iOS and Android
      })
    }
  },
  components: {
    OrderListItem,
    NavbarCenter
  }
}

</script>

<style lang="scss" scoped>

.order-item-container {
  display: flex;
  width: 100%;
}

.order-item-left-side {
  display: flex;
  flex-direction: column;
  width: 0px;
  flex-grow: 1;
}

.order-item-right-side {
  display: flex;
  flex-direction: column;
}

.order-item-list {
  display: flex;
  flex-wrap: wrap;
}

.order-item-row {
  display: flex;
  flex-wrap: wrap;
}

.order-item-cell {
  display: flex;
  flex-wrap: wrap;
  margin-left: 0.5rem;
}

.order-item-cell:first-child {
  margin-left: 0px;
}

.item-list__special-request {
  display: flex;
  color: red;
  overflow-x: hidden;
  width: 100%;
  padding: 0px 8px;
  box-sizing: border-box;
}
.item-line-through {
  text-decoration: line-through #888888 double;
}
.item-list__special-request-title {
  overflow : hidden;
  text-overflow : ellipsis;
  white-space : nowrap;
}

.item-list__special-request-icon {
  margin-left: auto;
  width: 20px;
}

</style>
